/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_EmptyInputs */

const en_fw_notify_empty = /** @type {(inputs: Fw_Notify_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No channel yet — nothing will be sent.`)
};

const id_fw_notify_empty = /** @type {(inputs: Fw_Notify_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada kanal — tidak ada yang dikirim.`)
};

/**
* | output |
* | --- |
* | "No channel yet — nothing will be sent." |
*
* @param {Fw_Notify_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_empty = /** @type {((inputs?: Fw_Notify_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_empty(inputs)
	return en_fw_notify_empty(inputs)
});